/* ============================================================
   Product builder (sections/product-builder.liquid), 2026-10-13

   One question per screen: Canvas or Print -> Framed or Unframed -> (Frame colour) -> Size -> Your car ->
   Review. Back / Next and the live subtotal sit in the sticky bar at the bottom of the form.

   The variant is always looked up from (Size, Product, Style) in the product's own variant list, written
   into items[0][id], and only choices Gelato actually sells are offered (no 20x30 on paper, no white frame
   on canvas). The form is submitted natively (multipart, for the photo); assets/order-atc.js adds the Meta
   AddToCart on the way out because the form carries data-order-form.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-product-builder]');
  var cfgEl = document.querySelector('[data-pb-config]');
  if (!root || !cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);

  var form = root.querySelector('[data-pb-form]');
  // show_form off: only the gallery is here (the order form is another section), so wire its arrows and dots and stop.
  if (!form) {
    initGallery();
    dockOrderForm();
    initCartBar();
    return;
  }

  // Sticky cart (2026-10-20, Wes): once the customer taps any printing option, a bar pinned to the bottom of
  // the screen shows what they picked, the total in large green type, and the order button. It copies the
  // order card's own summary and total, and its button presses the real one (same checks, same cart). It
  // steps aside while that real button is on screen, and while a text box has focus (an iPhone keyboard).
  function initCartBar() {
    var apv = document.querySelector('.apv.apv--product');
    if (!apv) return;
    var summary = apv.querySelector('[data-summary]');
    var total = apv.querySelector('.apv-buy--v2 [data-total]') || apv.querySelector('[data-total]');
    var was = apv.querySelector('.apv-buy--v2 [data-total-was]');
    var buy = apv.querySelector('.apv-buy--v2 [data-buy]') || apv.querySelector('[data-buy]');
    if (!summary || !total || !buy) return;

    var bar = document.createElement('div');
    bar.className = 'pb-cart';
    bar.hidden = true;
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Your order');
    bar.innerHTML =
      '<div class="pb-cart-in">' +
      '<div class="pb-cart-txt"><span class="pb-cart-what" data-cart-what></span>' +
      '<span class="pb-cart-price"><s data-cart-was hidden></s><strong data-cart-total></strong></span></div>' +
      '<button type="button" class="btn btn-chrome pb-cart-buy" data-cart-buy></button>' +
      '</div>';
    document.body.appendChild(bar);
    var whatEl = bar.querySelector('[data-cart-what]');
    var totalOut = bar.querySelector('[data-cart-total]');
    var wasOut = bar.querySelector('[data-cart-was]');
    var buyOut = bar.querySelector('[data-cart-buy]');

    var started = false;
    function copy() {
      var labels = Array.prototype.map.call(summary.querySelectorAll('.apv-summary-row-label'), function (el) {
        return el.textContent.trim();
      }).filter(Boolean);
      whatEl.textContent = labels.join(' + ');
      totalOut.textContent = total.textContent.trim();
      var w = was && !was.hidden && getComputedStyle(was).display !== 'none' ? was.textContent.trim() : '';
      wasOut.textContent = w;
      wasOut.hidden = !w;
      buyOut.textContent = buy.textContent.trim();
    }
    function place() {
      if (!started) return;
      var r = buy.getBoundingClientRect();
      var buyOnScreen = r.bottom > 0 && r.top < window.innerHeight && r.height > 0;
      var a = document.activeElement;
      var typing = a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA') && a.type !== 'checkbox' && a.type !== 'radio' && a.type !== 'file';
      var hide = buyOnScreen || typing;
      if (bar.hidden !== hide) {
        bar.hidden = hide;
        document.body.style.paddingBottom = hide ? '' : bar.offsetHeight + 'px';
      }
    }
    function start() {
      if (started) return;
      started = true;
      copy();
      place();
    }
    apv.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-v2-tab], [data-v2-frame], [data-v2-size]')) start();
    });
    // The photo is step 1 on this page, so adding it counts as the first selection too.
    apv.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-photo]') && e.target.files && e.target.files.length) start();
    });
    if (window.MutationObserver) {
      new MutationObserver(copy).observe(apv.querySelector('.apv-buy--v2') || apv, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
    }
    buyOut.addEventListener('click', function () {
      buy.click();
    });
    window.addEventListener('scroll', place, { passive: true });
    window.addEventListener('resize', place);
    document.addEventListener('focusin', place);
    document.addEventListener('focusout', function () {
      setTimeout(place, 0);
    });
  }

  // Desktop (2026-10-18, Wes): the Order Form section (.apv.is-order, placed right after this one) moves into the
  // right-hand column beside the sticky gallery, under the title, price and signature. Below 901px it goes back
  // to its own section, which already sits straight under the signature. Its listeners travel with the nodes.
  function dockOrderForm() {
    var main = root.querySelector('.pb-main');
    var apv = document.querySelector('.apv.is-order');
    if (!main || !apv || !window.matchMedia) return;
    var home = apv.parentNode;
    var mq = window.matchMedia('(min-width: 901px)');
    var place = function () {
      var to = mq.matches ? main : home;
      if (apv.parentNode !== to) to.appendChild(apv);
      root.classList.toggle('pb--docked', mq.matches);
    };
    place();
    if (mq.addEventListener) mq.addEventListener('change', place);
    else if (mq.addListener) mq.addListener(place);
    window.addEventListener('resize', place);
  }
  var variantInput = form.querySelector('[data-pb-variant]');
  var dupeId = form.querySelector('[data-pb-dupe-id]');
  var dupeFields = form.querySelectorAll('[data-pb-dupe-field]');
  var dupeBox = form.querySelector('[data-pb-dupe]');
  var photo = form.querySelector('[data-pb-photo]');
  var later = form.querySelector('[data-pb-later]');
  var laterBox = later && later.closest('.pb-later');
  var err = form.querySelector('[data-pb-err]');
  var nextBtn = form.querySelector('[data-pb-next]');
  var checkoutBtn = form.querySelector('[data-pb-checkout]');
  var backBtn = form.querySelector('[data-pb-back]');
  var totalEl = form.querySelector('[data-pb-total]');
  var fromEl = root.querySelector('[data-pb-from]');
  var progressEl = form.querySelector('[data-pb-progress]');

  // ── Variants ────────────────────────────────────────────────
  function optIndex(name) {
    var i = CFG.options.indexOf(name);
    return i < 0 ? 0 : i;
  }
  var iSize = optIndex(CFG.optSize);
  var iProd = optIndex(CFG.optProduct);
  var iStyle = optIndex(CFG.optStyle);

  // "50x75 cm / 20x30″" -> "20x30″" (the key), "20 × 30″" (the label), [20, 30] (inches)
  function sizeKey(v) {
    return String(v).split('/').pop().replace(/\s+/g, '');
  }
  function sizeLabel(key) {
    return key.replace('x', ' × ');
  }
  function sizeInches(key) {
    var m = key.match(/(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)/);
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : [12, 18];
  }

  var variants = CFG.variants.filter(function (v) {
    return v.available;
  }).map(function (v) {
    return { id: v.id, price: v.price, img: v.img, size: sizeKey(v.options[iSize]), prod: v.options[iProd], style: v.options[iStyle] };
  });

  var allSizes = [];
  variants.forEach(function (v) {
    if (allSizes.indexOf(v.size) < 0) allSizes.push(v.size);
  });
  allSizes.sort(function (a, b) {
    var x = sizeInches(a), y = sizeInches(b);
    return x[0] * x[1] - y[0] * y[1];
  });

  function prodFor(material, framed) {
    return CFG.products[material][framed ? 'framed' : 'unframed'];
  }
  function styleFor(framed, color) {
    return framed ? CFG.styles[color] : CFG.styles.none;
  }
  function matches(q) {
    return variants.filter(function (v) {
      return (
        (q.material == null || v.prod === prodFor(q.material, q.framed)) &&
        (q.color == null || v.style === styleFor(q.framed, q.color)) &&
        (q.size == null || v.size === q.size)
      );
    });
  }
  function cheapest(list) {
    return list.reduce(function (min, v) {
      return !min || v.price < min.price ? v : min;
    }, null);
  }
  function money(cents) {
    var d = cents / 100;
    return '$' + (cents % 100 ? d.toFixed(2) : String(d));
  }

  // ── State ───────────────────────────────────────────────────
  var state = {
    material: CFG.defaults.material === 'print' ? 'print' : 'canvas',
    framed: CFG.defaults.framed !== false,
    color: CFG.defaults.color || 'black',
    size: String(CFG.defaults.size || '').replace(/\s+/g, ''),
    dupe: false,
    step: 0
  };

  function colorsFor(material) {
    return ['black', 'natural', 'dark', 'white'].filter(function (c) {
      return matches({ material: material, framed: true, color: c }).length > 0;
    });
  }
  function sizesFor(st) {
    st = st || state;
    return allSizes.filter(function (s) {
      return matches({ material: st.material, framed: st.framed, color: st.color, size: s }).length > 0;
    });
  }

  // Keep a state (the real one, or a what-if copy) on something Gelato sells.
  function settle(st) {
    st = st || state;
    if (st.framed) {
      var cs = colorsFor(st.material);
      if (!cs.length) st.framed = false;
      else if (cs.indexOf(st.color) < 0) st.color = cs[0];
    }
    var ss = sizesFor(st);
    if (ss.indexOf(st.size) < 0 && ss.length) {
      // Nearest size by area to the one that disappeared.
      var want = sizeInches(st.size);
      ss.sort(function (a, b) {
        var x = sizeInches(a), y = sizeInches(b);
        return Math.abs(x[0] * x[1] - want[0] * want[1]) - Math.abs(y[0] * y[1] - want[0] * want[1]);
      });
      st.size = ss[0];
    }
    return st;
  }

  function current(st) {
    st = st || state;
    return matches({ material: st.material, framed: st.framed, color: st.color, size: st.size })[0] || null;
  }

  // What the piece would cost with one choice changed (the rest of the current choices kept).
  function priceWith(change) {
    var st = { material: state.material, framed: state.framed, color: state.color, size: state.size };
    Object.keys(change).forEach(function (k) {
      st[k] = change[k];
    });
    var v = current(settle(st));
    return v ? v.price : null;
  }

  // "+$50" in the photo's corner: the extra over the cheapest choice in the same step. Nothing for the cheapest.
  function setAdd(tile, price, base) {
    var badge = tile.querySelector('[data-pb-add]');
    if (!badge) return;
    var extra = price != null && base != null ? price - base : 0;
    badge.hidden = !(extra > 0);
    badge.innerHTML = extra > 0 ? '<span class="flame">+' + money(extra) + '</span>' : '';
  }
  function minOf(prices) {
    var m = null;
    prices.forEach(function (p) {
      if (p != null && (m == null || p < m)) m = p;
    });
    return m;
  }
  function optEl(tile) {
    return tile.closest('.pb-opt') || tile;
  }

  var chosen = { material: false, framed: false, color: false, size: false };

  // ── Steps ───────────────────────────────────────────────────
  function steps() {
    var s = ['material', 'framed'];
    if (state.framed) s.push('color');
    return s.concat(['size', 'car', 'review']);
  }
  var stepEls = {};
  Array.prototype.forEach.call(form.querySelectorAll('[data-pb-step]'), function (el) {
    stepEls[el.getAttribute('data-pb-step')] = el;
  });

  function showStep(i, scroll) {
    var list = steps();
    state.step = Math.max(0, Math.min(i, list.length - 1));
    var name = list[state.step];
    Object.keys(stepEls).forEach(function (k) {
      stepEls[k].hidden = k !== name;
    });
    var last = state.step === list.length - 1;
    backBtn.hidden = state.step === 0;
    nextBtn.hidden = last;
    checkoutBtn.hidden = !last;
    if (typeof placeBar === 'function') setTimeout(placeBar, 0);
    progressEl.textContent = String(CFG.stepLabel || 'Step [n]')
      .replace('[n]', state.step + 1)
      .replace('[total]', list.length);
    if (scroll) {
      var hd = document.querySelector('.hd');
      var top = progressEl.getBoundingClientRect().top;
      var offset = (hd ? hd.getBoundingClientRect().height : 0) + 12;
      if (top < offset || top > window.innerHeight * 0.45) {
        window.scrollTo({ top: window.pageYOffset + top - offset, behavior: 'smooth' });
      }
    }
  }
  function stepName() {
    return steps()[state.step];
  }

  // ── Rendering ───────────────────────────────────────────────
  function pickTiles(group) {
    return Array.prototype.slice.call(form.querySelectorAll('[data-pb-pick="' + group + '"]'));
  }
  function setChecked(tiles, value) {
    tiles.forEach(function (t) {
      t.setAttribute('aria-checked', t.getAttribute('data-value') === value ? 'true' : 'false');
    });
  }
  function setImg(tile, src) {
    var img = tile.querySelector('[data-pb-tile-img]');
    if (img && src && img.getAttribute('src') !== src) {
      img.loading = 'eager';
      img.setAttribute('src', src);
    }
  }

  var FRAME_COLORS = { black: '#141414', natural: '#b88a57', dark: '#4b3122', white: '#eeeeee' };

  // The artwork drawn to scale (1 unit = 1 inch) on a wall above an 84" sofa.
  // The artwork drawn to scale on the wall of Wes's room photo (assets/pb-room.webp, 1024 x 1024). In that photo
  // the sofa runs from about x=105 to x=925 px; taking it as 84" gives ROOM_PPI px per inch. The art is centred on
  // the sofa with its bottom edge ROOM_ART_BOTTOM px down, about 8" above the sofa back. The view is cropped in a
  // little (ROOM_VIEW) so the art reads larger in a small tile.
  var ROOM_PPI = 820 / 84;
  var ROOM_CX = 515;
  var ROOM_ART_BOTTOM = 554;
  var ROOM_VIEW = '90 130 860 860';
  function sizeSvg(key) {
    var d = sizeInches(key);
    var w = Math.max(d[0], d[1]) * ROOM_PPI;
    var h = Math.min(d[0], d[1]) * ROOM_PPI;
    var x = ROOM_CX - w / 2;
    var y = ROOM_ART_BOTTOM - h;
    var t = 1.1 * ROOM_PPI; // frame moulding, about 1.1"
    var shadow = '<rect x="' + (x + 5) + '" y="' + (y + 9) + '" width="' + w + '" height="' + h + '" fill="rgba(0,0,0,.28)"/>';
    var frame = state.framed
      ? '<rect x="' + (x - t) + '" y="' + (y - t) + '" width="' + (w + 2 * t) + '" height="' + (h + 2 * t) + '" fill="' + FRAME_COLORS[state.color] + '"/>'
      : '';
    return (
      '<svg viewBox="' + ROOM_VIEW + '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice">' +
      '<image href="' + CFG.roomUrl + '" x="0" y="0" width="1024" height="1024"/>' +
      shadow +
      frame +
      '<image href="' + CFG.artUrl + '" x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" preserveAspectRatio="xMidYMid slice"/>' +
      '</svg>'
    );
  }

  // Matching one-artwork mockup for a finish and frame colour ('none' = unframed); null if there isn't one.
  function frameImg(material, color) {
    var m = CFG.frameImgs && CFG.frameImgs[material];
    return (m && m[color]) || null;
  }

  var sizeWrap = form.querySelector('[data-pb-sizes]');
  function renderSizes() {
    var avail = sizesFor();
    var pop = String(CFG.popularSize || '').replace(/\s+/g, '');
    var base = minOf(avail.map(function (key) {
      return priceWith({ size: key });
    }));
    sizeWrap.innerHTML = '';
    avail.forEach(function (key) {
      var v = matches({ material: state.material, framed: state.framed, color: state.color, size: key })[0];
      var extra = v && base != null ? v.price - base : 0;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pb-tile';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', key === state.size ? 'true' : 'false');
      b.setAttribute('data-value', key);
      b.innerHTML =
        '<span class="pb-tile-img">' +
        
        sizeSvg(key) +
        (extra > 0 ? '<span class="pb-add"><span class="flame">+' + money(extra) + '</span></span>' : '') +
        '</span><span class="pb-tile-name">' + sizeLabel(key) +
        (key === pop && CFG.popularLabel ? ' <span class="pb-tag">' + CFG.popularLabel + '</span>' : '') +
        '</span>';
      b.addEventListener('click', function () {
        state.size = key;
        chosen.size = true;
        render(true);
      });
      sizeWrap.appendChild(b);
    });
  }

  // Smooth-scroll a slider, then make sure it arrived: where smooth scrolling never runs (a hidden tab, some
  // older browsers) jump there instead, so an arrow tap can never do nothing.
  function slideTo(track, left) {
    track.scrollTo({ left: left, behavior: 'smooth' });
    setTimeout(function () {
      if (Math.abs(track.scrollLeft - left) > 2) track.scrollLeft = left;
    }, 700);
  }

  var gallerySynced = null;
  function syncGallery(v) {
    if (!v || !v.img || v.img === gallerySynced) return;
    var slide = root.querySelector('[data-pb-img="' + v.img + '"]');
    gallerySynced = v.img;
    if (!slide) return;
    var track = slide.parentElement;
    slideTo(track, slide.offsetLeft - track.offsetLeft);
  }

  function render(userChange) {
    settle();
    var v = current();

    // 1. material
    var mTiles = pickTiles('material');
    setChecked(mTiles, state.material);
    var mPrices = mTiles.map(function (t) {
      return priceWith({ material: t.getAttribute('data-value') });
    });
    var mBase = minOf(mPrices);
    mTiles.forEach(function (t, i) {
      setAdd(t, mPrices[i], mBase);
    });

    // 2. framed
    var fTiles = pickTiles('framed');
    setChecked(fTiles, state.framed ? 'yes' : 'no');
    var fPrices = fTiles.map(function (t) {
      return priceWith({ framed: t.getAttribute('data-value') === 'yes' });
    });
    var fBase = minOf(fPrices);
    fTiles.forEach(function (t, i) {
      var framed = t.getAttribute('data-value') === 'yes';
      var list = matches({ material: state.material, framed: framed, color: framed ? state.color : null });
      if (framed && !list.length) list = matches({ material: state.material, framed: true });
      var c = cheapest(list);
      optEl(t).hidden = !c;
      var shown = framed ? (colorsFor(state.material).indexOf(state.color) >= 0 ? state.color : 'black') : 'none';
      setImg(t, frameImg(state.material, shown) || (c && c.img));
      var desc = optEl(t).querySelector('[data-pb-desc-canvas]');
      if (desc) desc.textContent = desc.getAttribute(state.material === 'print' ? 'data-pb-desc-print' : 'data-pb-desc-canvas');
      setAdd(t, fPrices[i], fBase);
    });

    // 2b. colour
    var cTiles = pickTiles('color');
    var cs = colorsFor(state.material);
    setChecked(cTiles, state.color);
    var cPrices = cTiles.map(function (t) {
      var col = t.getAttribute('data-value');
      return cs.indexOf(col) < 0 ? null : priceWith({ framed: true, color: col });
    });
    var cBase = minOf(cPrices);
    cTiles.forEach(function (t, i) {
      var col = t.getAttribute('data-value');
      optEl(t).hidden = cs.indexOf(col) < 0;
      var c = cheapest(matches({ material: state.material, framed: true, color: col }));
      setImg(t, frameImg(state.material, col) || (c && c.img));
      setAdd(t, cPrices[i], cBase);
    });

    // 3. size
    renderSizes();

    // Totals, cart fields
    if (v) {
      variantInput.value = v.id;
      dupeId.value = v.id;
    }
    var price = v ? v.price : 0;
    var dupePrice = Math.round((price * (100 - (CFG.dupePercent || 0))) / 100);
    var dupeOn = !!(state.dupe && v);
    dupeId.disabled = !dupeOn;
    Array.prototype.forEach.call(dupeFields, function (f) {
      f.disabled = !dupeOn;
    });
    var total = v ? price + (dupeOn ? dupePrice : 0) : null;

    // Summary above both prices, built up as the customer answers: nothing until the first pick, then
    // "Canvas", "Canvas · Black Frame", "Canvas · Black Frame · 20 × 30″".
    var N = CFG.pickNames || {};
    var parts = [];
    if (v && chosen.material) parts.push(N[state.material]);
    if (v && chosen.framed) {
      if (!state.framed) parts.push(N.unframed);
      else if (chosen.color) parts.push(CFG.frameLabels[state.color] + ' ' + (N.frameWord || 'Frame'));
      else parts.push(N.framed);
    }
    if (v && chosen.size) parts.push(sizeLabel(state.size));
    var pickSum = parts.join(' · ') + (parts.length && dupeOn && N.dupe ? ' ' + N.dupe : '');
    Array.prototype.forEach.call(root.querySelectorAll('[data-pb-pick-sum]'), function (el) {
      el.textContent = pickSum;
    });
    totalEl.textContent = total != null ? money(total) : '—';
    if (fromEl && total != null) {
      fromEl.textContent = money(total);
      // "From" only while the subtotal IS the lowest price; after that it is the exact price.
      var lowest = cheapest(variants);
      if (lowest && total === lowest.price) fromEl.parentElement.removeAttribute('data-exact');
      else fromEl.parentElement.setAttribute('data-exact', '');
    }
    nextBtn.disabled = !v;

    // The sunset ring on the selected tile only once the customer has answered that step (a tap, or Next on
    // the default): until then the default is selected but not highlighted.
    Object.keys(chosen).forEach(function (k) {
      if (stepEls[k]) stepEls[k].classList.toggle('is-picked', !!chosen[k]);
    });

    // 5. review
    renderMock();
    var summary = form.querySelector('[data-pb-summary]');
    if (summary && v) {
      summary.textContent =
        sizeLabel(state.size) + ' ' + CFG.names[state.material][state.framed ? 'framed' : 'unframed'] +
        (state.framed ? ' · ' + CFG.frameLabels[state.color] + ' frame' : '');
      form.querySelector('[data-pb-line-price]').textContent = money(price);
    }
    var dp = form.querySelector('[data-pb-dupe-price]');
    if (dp) dp.textContent = '+' + money(dupePrice);
    var rp = form.querySelector('[data-pb-review-photo]');
    if (rp) {
      var f = photo.files && photo.files[0];
      rp.textContent = f ? String(CFG.photoReview || '').replace('[file]', f.name) : later.checked ? CFG.photoLaterReview : '';
    }

    if (userChange) syncGallery(v);
    // Framed/unframed changes the number of steps: keep "Step n of N" and the buttons right.
    if (stepEls[steps()[state.step]] && stepEls[steps()[state.step]].hidden === false) showStep(state.step, false);
  }

  // ── Review preview: their photo in the piece they picked ──────
  var mock = form.querySelector('[data-pb-mock]');
  var descIn = form.querySelector('input[name="items[0][properties][Description]"]');
  function renderMock() {
    if (!mock) return;
    var piece = mock.querySelector('[data-pb-mock-piece]');
    var frameEl = mock.querySelector('[data-pb-mock-frame]');
    var mat = mock.querySelector('[data-pb-mock-mat]');
    var img = mock.querySelector('[data-pb-mock-photo]');
    var fr = state.framed && CFG.mockFrames && CFG.mockFrames[state.material] && CFG.mockFrames[state.material][state.color];
    piece.classList.toggle('is-wrap', !fr && state.material === 'canvas');
    piece.classList.toggle('is-paper', !fr && state.material === 'print');
    if (fr) {
      // The frame photo is wider than the art by its opening; the art keeps the same size either way.
      piece.style.width = (68.9 / (fr.w / 100)).toFixed(3) + 'cqw';
      piece.style.aspectRatio = String(fr.ratio);
      frameEl.src = fr.url;
      frameEl.hidden = false;
      mat.style.cssText = 'left:' + fr.left + '%;top:' + fr.top + '%;width:' + fr.w + '%;height:' + fr.h + '%';
    } else {
      piece.style.width = '';
      piece.style.aspectRatio = '3 / 2';
      frameEl.hidden = true;
      frameEl.removeAttribute('src');
      mat.style.cssText = 'left:0;top:0;width:100%;height:100%';
    }
    var own = !!thumbUrl && !thumbBad;
    var src = own ? thumbUrl : CFG.artUrl;
    if (img.getAttribute('src') !== src) img.src = src;
    var desc = descIn && descIn.value.trim();
    mock.querySelector('[data-pb-mock-who]').textContent = desc || CFG.mockWho || '';
    var pieceName = CFG.names[state.material][state.framed ? 'framed' : 'unframed'] +
      (state.framed ? ' · ' + CFG.frameLabels[state.color] + ' frame' : '');
    mock.querySelector('[data-pb-mock-spec]').textContent = pieceName + ' · ' + sizeLabel(state.size);
    var note = form.querySelector('[data-pb-mock-note]');
    // 'Black Framed Canvas', 'Wrapped Canvas', 'Fine Art Print'.
    var noteName = (state.framed ? CFG.frameLabels[state.color] + ' ' : '') + CFG.names[state.material][state.framed ? 'framed' : 'unframed'];
    if (note) note.textContent = String((own ? CFG.mockNote : CFG.mockNoteSample) || '').replace('[piece]', noteName);
  }
  if (descIn) descIn.addEventListener('input', renderMock);

  // ── Choices ─────────────────────────────────────────────────
  pickTiles('material').forEach(function (t) {
    t.addEventListener('click', function () {
      state.material = t.getAttribute('data-value');
      chosen.material = true;
      render(true);
    });
  });
  pickTiles('framed').forEach(function (t) {
    t.addEventListener('click', function () {
      state.framed = t.getAttribute('data-value') === 'yes';
      chosen.framed = true;
      render(true);
    });
  });
  pickTiles('color').forEach(function (t) {
    t.addEventListener('click', function () {
      state.color = t.getAttribute('data-value');
      chosen.color = true;
      render(true);
    });
  });
  if (dupeBox) {
    dupeBox.addEventListener('change', function () {
      state.dupe = dupeBox.checked;
      render(false);
    });
  }

  // ── Photo ───────────────────────────────────────────────────
  var upload = form.querySelector('[data-pb-upload]');
  var thumb = form.querySelector('[data-pb-thumb]');
  var uploadTxt = form.querySelector('[data-pb-upload-txt]');
  var uploadHint = form.querySelector('[data-pb-upload-hint]');
  var removeBtn = form.querySelector('[data-pb-photo-remove]');
  var ok = form.querySelector('[data-pb-ok]');
  var okTxt = form.querySelector('[data-pb-ok-txt]');
  var thumbBad = false; // the browser could not draw this photo (the review preview then shows the sample)
  var uploadTxtDefault = uploadTxt.textContent;
  var uploadHintDefault = uploadHint.textContent;
  var thumbUrl = null;

  function hasPhoto() {
    return !!(photo.files && photo.files.length);
  }
  // A photo OR "I'll email it later", never both (2026-10-14): with both, the pipeline used the photo and quietly
  // ignored the box, so a customer who meant "placeholder, a better one is coming" got no follow-up.
  function syncLater() {
    if (!laterBox) return;
    var has = hasPhoto();
    if (has) later.checked = false;
    laterBox.hidden = has;
  }
  function showErr(msg) {
    err.textContent = msg;
    err.hidden = false;
  }
  function clearPhoto() {
    photo.value = '';
    if (thumbUrl) URL.revokeObjectURL(thumbUrl);
    thumbUrl = null;
    thumb.hidden = true;
    upload.classList.remove('is-done');
    uploadTxt.textContent = uploadTxtDefault;
    uploadHint.textContent = uploadHintDefault;
    removeBtn.hidden = true;
    if (ok) ok.hidden = true;
    syncLater();
  }
  // "Photo added. It will work great!" once the picture has loaded; the gentler line for a small one. A photo the
  // browser can't draw (some HEIC files) still counts as added: it uploads fine, there is just no thumbnail.
  function confirmPhoto() {
    if (!ok) return;
    var w = thumb.naturalWidth, h = thumb.naturalHeight;
    var small = w && h && Math.max(w, h) < 1000;
    okTxt.textContent = (small ? CFG.uploadOkSmall : CFG.uploadOk) || CFG.uploadOk || '';
    ok.hidden = false;
  }
  thumb.addEventListener('load', function () {
    if (thumbUrl) confirmPhoto();
  });
  thumb.addEventListener('error', function () {
    if (!thumbUrl) return;
    thumb.hidden = true;
    thumbBad = true;
    confirmPhoto();
    render(false);
  });
  photo.addEventListener('change', function () {
    var f = photo.files && photo.files[0];
    if (!f) return clearPhoto();
    if (f.size > (CFG.maxUploadMb || 20) * 1024 * 1024) {
      clearPhoto();
      return showErr(CFG.tooBig);
    }
    err.hidden = true;
    if (thumbUrl) URL.revokeObjectURL(thumbUrl);
    thumbUrl = URL.createObjectURL(f);
    thumbBad = false;
    thumb.src = thumbUrl;
    thumb.hidden = false;
    upload.classList.add('is-done');
    uploadTxt.textContent = f.name;
    uploadHint.textContent = '';
    removeBtn.hidden = false;
    syncLater();
    render(false);
  });
  removeBtn.addEventListener('click', function () {
    clearPhoto();
    render(false);
  });
  later.addEventListener('change', function () {
    if (later.checked) err.hidden = true;
    render(false);
  });

  function carOk() {
    if (hasPhoto() || later.checked) return true;
    showErr(err.getAttribute('data-default') || err.textContent);
    return false;
  }
  err.setAttribute('data-default', err.textContent);

  // ── Navigation ──────────────────────────────────────────────
  nextBtn.addEventListener('click', function () {
    if (stepName() === 'car' && !carOk()) return;
    // Next on an option step accepts what is selected there, so it joins the summary.
    if (chosen.hasOwnProperty(stepName())) {
      chosen[stepName()] = true;
      render(false);
    }
    showStep(state.step + 1, true);
  });
  backBtn.addEventListener('click', function () {
    showStep(state.step - 1, true);
  });

  // Enter in a text field, or Checkout before everything is filled: never leave half done.
  form.addEventListener('submit', function (e) {
    if (stepName() !== 'review') {
      e.preventDefault();
      if (stepName() === 'car' && !carOk()) return;
      showStep(state.step + 1, true);
      return;
    }
    if (!current()) {
      e.preventDefault();
      showStep(0, true);
      return;
    }
    if (!hasPhoto() && !later.checked) {
      e.preventDefault();
      showStep(steps().indexOf('car'), true);
      carOk();
    }
  });

  // ── Gallery dots ────────────────────────────────────────────
  initGallery();
  function initGallery() {
  var track = root.querySelector('[data-pb-track]');
  var dotsEl = root.querySelector('[data-pb-dots]');
  if (track && dotsEl) {
    var slides = track.children;
    for (var i = 0; i < slides.length; i++) dotsEl.appendChild(document.createElement('span'));
    var dots = dotsEl.children;
    var onScroll = function () {
      var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-on', j === n);
    };
    track.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    Array.prototype.forEach.call(root.querySelectorAll('[data-pb-nav]'), function (btn) {
      btn.addEventListener('click', function () {
        var n = slides.length;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        var to = (i + Number(btn.getAttribute('data-pb-nav')) + n) % n;
        slideTo(track, to * track.clientWidth);
      });
    });
  }
  }

  // ── Bar: pinned once it has scrolled out of view ─────────────
  // The spacer marks the bar's slot under the options (height 0 while the bar sits in it). The bar is pinned to
  // the bottom of the screen only while that whole slot is out of view above the screen (behind the header), i.e.
  // once the visitor has scrolled on past it; it goes back into the slot as soon as any of the slot is visible again.
  // While pinned the page gets matching bottom padding so the footer can still be read above it.
  var bar = form.querySelector('[data-pb-bar]');
  var spacer = form.querySelector('[data-pb-bar-spacer]');
  // The bar is a different height in its slot (box padding) than pinned, so the slot's height is measured while
  // the bar sits in it and kept for the spacer; using the pinned height would leave it pinned on the way back up.
  var slotH = 0;
  function placeBar() {
    if (!bar || !spacer) return;
    var fixed = bar.classList.contains('is-fixed');
    if (!fixed) slotH = bar.offsetHeight;
    var slotBottom = spacer.getBoundingClientRect().top + slotH;
    var hd = document.querySelector('.hd');
    var hdBottom = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;
    var pin = slotBottom <= hdBottom;
    if (pin !== fixed) bar.classList.toggle('is-fixed', pin);
    spacer.style.height = pin ? slotH + 'px' : '0px';
    document.body.style.paddingBottom = pin ? bar.offsetHeight + 'px' : '';
  }
  window.addEventListener('scroll', placeBar, { passive: true });
  window.addEventListener('resize', placeBar);

  // "Start your artwork": on a phone the options begin below the first screen, so this is the one thing to tap
  // there. Shown only while Step 1 is still below the screen and nothing has been picked; gone for good once
  // Step 1 is in view, a tile is tapped, or it is used (then it scrolls to Step 1).
  var startBtn = root.querySelector('[data-pb-start]');
  if (startBtn) {
    var startDone = false;
    var endStart = function () {
      startDone = true;
      startBtn.hidden = true;
      window.removeEventListener('scroll', checkStart);
    };
    var checkStart = function () {
      if (startDone) return;
      var narrow = window.matchMedia('(max-width: 900px)').matches;
      var below = progressEl.getBoundingClientRect().top > window.innerHeight - 90;
      if (!narrow) return (startBtn.hidden = true);
      if (!below) return endStart();
      startBtn.hidden = false;
    };
    startBtn.addEventListener('click', function () {
      endStart();
      var hd = document.querySelector('.hd');
      var offset = (hd ? hd.getBoundingClientRect().height : 0) + 12;
      var top = window.pageYOffset + progressEl.getBoundingClientRect().top - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      setTimeout(function () {
        if (Math.abs(window.pageYOffset - top) > 40) window.scrollTo(0, top);
      }, 700);
    });
    form.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-pb-pick]')) endStart();
    });
    window.addEventListener('scroll', checkStart, { passive: true });
    window.addEventListener('resize', checkStart);
    checkStart();
  }

  render(false);
  showStep(0, false);
  placeBar();
})();
